import React, { useEffect, useState } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import DynamicProductList from "../DynamicProductList/FeaturedProductList";

import "./FeaturedProducts.styles.css";
 
const FeaturedProducts = ({ firstprop, secondProp }) => {

  const [productList, setProductList] = useState([]);

    const getProducts = async () => {
        await Axios.get('/cms/home-featured-item')
        .then(function (response) {
            if (response.data) {
            const responseData = response.data;
            if (responseData.length > 0) { 
                setProductList(responseData);
            }
            else {
                setProductList([]);
            }
            }
        })
        .catch(function (error) {
            setProductList([]);
        });
    };

    useEffect(() => {
        getProducts();
    }, [])

    var RenderNav = () =>{
      return (
        <Nav className="nav navbar-nav">
          {productList?.map((data, index) => {
            return (
              <Nav.Item key={index}>
                <Nav.Link eventKey={data.matgp}>{data.matgpname}</Nav.Link>
              </Nav.Item>
            )
          })}
        </Nav>
      );
    };

  return (
    <div className="content-page">
      <Container fluid>
        {/* <!-- Product Tabs--> */}
        <div className="category-product">
        {productList && productList.length > 0 &&
          <Tab.Container id="left-tabs-example" defaultActiveKey='P80'>
            <div className="navbar nav-menu">
              <div className="navbar-collapse">
                <div className="jtv-title">
                  <h2>{firstprop || 'Featured Products'}</h2>
                </div>
                <RenderNav/>
              </div>
              {/* <!-- /.navbar-collapse --> */}
            </div>
            <Tab.Content>
            {productList?.map((data, index) => {
              return (  
                <Tab.Pane eventKey={data.matgp} key={index}>
                  {
                    <DynamicProductList productList={data.item} showSortBy={false}/> 
                  }
                </Tab.Pane>
                )
              })}
              

            </Tab.Content>
          </Tab.Container>
          }
        </div>
      </Container>
    </div>
  );
};

export default FeaturedProducts;
